// Catálogo de las 15 etapas del "Avance del procedimiento" y su agrupación
// en fases. Vive aparte para que TabExpedienteActuaciones.jsx y
// EsquemaProcedimiento.jsx lo compartan sin depender uno del otro.
export const ESQ = [
  "Presentación de demanda", "Admisión", "Emplazamiento", "Contestación",
  "Reconvención", "Réplica", "Contrarréplica", "Integración de la litis",
  "Audiencia conciliatoria", "Audiencia preliminar", "Audiencia de juicio", "Sentencia / laudo",
  "Amparo", "Ejecución", "Terminación",
];
export const ESQG = { 0: "Fase escrita", 8: "Fase oral", 12: "Posteriores" };
